(function (window) {
    "use strict";
    function defineProductHelper() {
        let productHelper = {};
        productHelper.productType = {
            delivery: 1,
            collection: 2
        };
        return productHelper;
    }
    //define globally if it doesn't already exist
    if (typeof (productHelper) === "undefined") {
        window.productHelper = defineProductHelper();
    } else {
        console.log("productHelper already defined.");
    }
})(window);